import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { RouteRepository } from '../application/RouteRepository'

export function createResilientRouteRepository(
  primary: RouteRepository,
  fallback: RouteRepository,
): RouteRepository {
  return {
    async listActiveRoutes() {
      try {
        return await primary.listActiveRoutes()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'routes', operation: 'list-active', fallback: true })
        const result = await fallback.listActiveRoutes()
        return {
          ...result,
          meta: { ...result.meta, source: 'fixture-fallback', fallbackReason: 'ROUTES_REMOTE_UNAVAILABLE' },
        }
      }
    },
    async listUnassignedServiceLocations() {
      try {
        return await primary.listUnassignedServiceLocations()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'routes', operation: 'list-unassigned', fallback: true })
        const result = await fallback.listUnassignedServiceLocations()
        return {
          ...result,
          meta: { ...result.meta, source: 'fixture-fallback', fallbackReason: 'ROUTES_REMOTE_UNAVAILABLE' },
        }
      }
    },
    // Assigner une adresse et générer une Mission sont des écritures : jamais
    // de repli silencieux sur des fixtures, l'erreur doit remonter telle quelle.
    assignServiceLocationToRoute(serviceLocationId, routeId) {
      return primary.assignServiceLocationToRoute(serviceLocationId, routeId)
    },
    generateMissionFromRoute(input) {
      return primary.generateMissionFromRoute(input)
    },
    // Préparation des routes : jamais de repli sur des fixtures. Une erreur de chargement ne doit pas
    // apparaître comme des routes vides ou zéro adresse non affectée (plan Routes §3.7).
    getPlanningSnapshot(season) {
      return primary.getPlanningSnapshot(season)
    },
    previewPlacement(input) {
      return primary.previewPlacement(input)
    },
    ensureSeasonRoutes(season) {
      return primary.ensureSeasonRoutes(season)
    },
    createRoute(command) {
      return primary.createRoute(command)
    },
    updateRoute(command) {
      return primary.updateRoute(command)
    },
    placeLocations(command) {
      return primary.placeLocations(command)
    },
    removeLocation(command) {
      return primary.removeLocation(command)
    },
    setLocationPosition(command) {
      return primary.setLocationPosition(command)
    },
    getMapSettings() {
      return primary.getMapSettings()
    },
    setMapSettings(settings) {
      return primary.setMapSettings(settings)
    },
    // Ajustement maison par maison : jamais de repli (une progression de démonstration passerait pour la vraie).
    getFlagWalkState(routeId) {
      return primary.getFlagWalkState(routeId)
    },
    verifyFlag(command) {
      return primary.verifyFlag(command)
    },
    undoFlagVerification(command) {
      return primary.undoFlagVerification(command)
    },
    setFlagWalkProgress(command) {
      return primary.setFlagWalkProgress(command)
    },
  }
}
